// Shared framer-motion variants and helpers.
export const EASE = [0.22, 1, 0.36, 1];
export const EASE_HERO = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 26 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE } },
};

export const stagger = (delayChildren = 0.05, staggerChildren = 0.09) => ({
  hidden: {},
  show: {
    transition: { delayChildren, staggerChildren },
  },
});

export const lineReveal = {
  hidden: { y: "110%" },
  show: {
    y: "0%",
    transition: { duration: 0.85, ease: EASE_HERO },
  },
};

export const viewportOnce = { once: true, margin: "-70px" };
